export default __webpack_public_path__ + "assets/c77db0d2a5178c724ea8ab9b5e359df9.png";